import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const TermsOfService = () => {
  return (
    <>
      <Navbar />

      <div className="max-w-5xl mx-auto px-6 py-12 bg-white shadow-lg rounded-xl">
        <h1 className="text-4xl font-bold mb-8 text-center text-gray-900">
          Terms of Service
        </h1>

        <div className="space-y-6 text-gray-700 leading-relaxed">
          <div>
            <h2 className="text-2xl font-semibold mb-2">Service Usage</h2>
            <p>
              Clients must provide accurate project details, site information,
              and requirements. ZajraGreen provides sports turf construction,
              installation, and related infrastructure services.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-2">Payments</h2>
            <p>
              All payments must be made as per the agreed quotation or contract
              terms. Delays in payment may result in project delays or temporary
              suspension of services.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-2">Project Timelines</h2>
            <p>
              We aim to complete projects within the committed timelines.
              However, timelines may be affected due to weather conditions,
              site readiness, material availability, or other unforeseen
              factors.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-2">Liability</h2>
            <p>
              ZajraGreen is not responsible for damages caused by external
              factors beyond reasonable control, including improper site
              maintenance after project handover or force majeure events.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-2">
              Cancellations & Refunds
            </h2>
            <p>
              Project cancellations must be communicated in writing. Refunds,
              if applicable, will be processed based on work completed and
              material procurement status.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-2">Modifications</h2>
            <p>
              ZajraGreen reserves the right to update or modify these Terms of
              Service at any time. Updates will be reflected on the website and
              will apply to future engagements.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default TermsOfService;
